export const ENDPOINTS = {
  dashboard: {
    reports: 'dashboard/report',
    favorites: 'dashboard/report/my-favorites',
    custom: {
      run: reportCode => `customreport/${reportCode}/run`,
      details: reportCode => `customreport/${reportCode}/viewsales`,
    },
    report: {
      run: reportID => `report/${reportID}/run`,
      details: reportID => `report/${reportID}/viewsales`,
      email: reportID => `report/${reportID}/email`,
      favorite: (reportID, chartID, addRemove) => `/report/${reportID}/chart/${chartID}/favorites/${addRemove ? 'add' : 'remove'}`,
      refreshKpi: 'report/refresh-kpi-views'
    },
  },
  session: {
    getConfiguration: 'application-configuration',
    login: 'authenticate',
    logout: 'logout',
    forgotPassword: 'reset-password',
    resetPassword: 'reset-password/new-password',
    checkToken: 'reset-password/token-confirm',
    googleSso: 'google-sso',
    requestCode: 'security-code-request',
    enterCode: 'security-code-authentication',
    chooseStore: 'change-dealership',
    extendSession: 'extend-session'
  },
  lookup: {
    inventorySource: 'lookup/inventory-source/list',
    inventorySourceNew: 'lookup/inventory-source/list',
    inventorySourceUsed: 'lookup/inventory-source/list',
    inventoryStatus: 'lookup/inventory-status/list',
    salesTypeCategory: 'lookup/sales-type-category/list',
    vehicleManagement: 'lookup/vehicle-management/list',
    vehicleMakes: 'lookup/vehicle-make/list',
    salesManagers: 'user/list-by-title', // Need to store these in redux separately due to different params
    salesStaff: 'user/list-by-title',
    employeeSalesStaff1: 'user/list-by-title',
    employeeSalesStaff2: 'user/list-by-title',
    employeeSalesManager1: 'user/list-by-title',
    employeeSalesManager2: 'user/list-by-title',
    fmAssignment: 'user/list-by-title',
    allUsers: 'user/all',
    financeStaff: 'amfinance/assignment-finance-staff',
    menuCount: 'sales/menu-counts',
    inventoryLocations: 'lookup/inventory-location/list',
    inventoryLocationsAtDealerNew: 'lookup/inventory-location/list',
    inventoryLocationsAtDealerUsed: 'lookup/inventory-location/list',
    inventoryLocationsNotAtDealerNew: 'lookup/inventory-location/list',
    inventoryLocationsNotAtDealerUsed: 'lookup/inventory-location/list',
    vendor: 'lookup/vendor/list',
    usaStates: 'lookup/states/list',
    lender: 'lookup/amfinance-funding-sources-lender/list',
    customer: 'lookup/amfinance-funding-sources-customer/list',
    states: 'lookup/states/list',
    warrantyTypes: 'lookup/warranty-type/list',
    downPayment: 'lookup/down-payment-type/list',
    storesByDealerGroup: 'user/stores-by-dealer-group',
    reportAggregateFunction: 'report/field/aggregate-functions',
    reportCategory: 'report/category/active',
    reportChartType: 'report/charttype',
    reportEmailAttachmentType: 'report/email/attachment-type',
    reportEmailFrequency: 'report/email/frequency',
    reportEmailDaterange: 'report/email/date-range',
    reportFilterOperations: 'report/field/filter-operations',
    reportFilterTypes: 'report/field/filter-types',
    reportField: 'report/field'
},
  amFinance: {
    list: 'sales/amfin',
    get: 'amfinance',
    assignment: {
      save: 'amfinance/assignment-update'
    },
    fundingSource: {
      save: salesId => `amfinance/funding-source-update/${salesId}`
    },
    products: {
      save: salesId => `sales/amfiproduct/${salesId}`,
      update: salesId => `amfinance/amfi-products-update/${salesId}`
    },
    dealDetails: {
      save: 'amfinance/deal-number-update'
    },
    checklist: {
      spotInstructions: 'amfinance/checklist-spotinstructions',
      dealCompletion: 'amfinance/checklist-dealchecklist',
      save: 'amfinance/checklist-update'
    },
    status: salesId => `sales/${salesId}/update-amfinance-status`,
    processThroughFinance: salesId => `amfinance/process-through-finance-update/${salesId}`
  },
  dealTasks: {
    list: 'deal-tasks/list',
    complete: 'deal-tasks/completed',
    comment: {
      add: 'deal-tasks/submit-comment',
      delete: 'deal-tasks/delete-comment'
    }
  },
  inventory: {
    list: 'inventory/list',
    single: 'inventory',
    decodeVin: 'decode-vin',
    updateAdvertisedPrice: 'inventory/update-adjusted-price',
    comments: {
      list: 'inventory-comments/list',
      add: 'inventory-comments/add',
      delete: 'inventory-comments/delete'
    },
    salesActivity: inventoryID => `inventory-sales-activity/${inventoryID}`,
    activityLog: inventoryID => `inventory-activity/${inventoryID}`,
    return: 'inventory/return-vehicle',
    ePost: 'inventory/epost',
    updateWholeSale: 'inventory/updateIsForWholeSale',
    convert: 'inventory/convert-vehicle',
    updateTracking: 'inventory/tracking',
    repair: {
      save: dailySalesInventoryId => `inventory/${dailySalesInventoryId}/repair-invoice`,
      delete: (dailySalesInventoryId, inventoryRepairInvoiceId) => `/inventory/${dailySalesInventoryId}/repair-invoice/${inventoryRepairInvoiceId}`,
      upload: 'upload/inventory/repair-invoice',
      viewAttachment: (inventoryId, inventoryRepairInvoiceId, inventoryRepairAttachmentId) =>
        `inventory/${inventoryId}/repair-invoice/${inventoryRepairInvoiceId}/attachment/${inventoryRepairAttachmentId}`,
      deleteAttachment: (inventoryId, inventoryRepairInvoiceId, inventoryRepairAttachmentId) =>
        `inventory/${inventoryId}/repair-invoice/${inventoryRepairInvoiceId}/attachment/${inventoryRepairAttachmentId}`
    },
    imvInfo: 'inventory/getInventoryIMV',
    updateAdjustedPrice: 'inventory/update-adjusted-price',
    updateWarrantyType: 'inventory/updWarrantyType',
    updateImvInfo: 'inventory/updInventoryIMV',
    miscTask: {
      addTask: inventoryId => `inventory/${inventoryId}/misc-task`,
      updateTask: (inventoryId, trackMiscTaskId) => `inventory/${inventoryId}/misc-task/${trackMiscTaskId}`,
      getTaskComments: (inventoryId, trackMiscTaskId) =>
        `inventory/${inventoryId}/misc-task/${trackMiscTaskId}/comment`,
      addTaskComment: (inventoryId, trackMiscTaskId) => `inventory/${inventoryId}/misc-task/${trackMiscTaskId}/comment`,
      deleteTaskComment: (inventoryId, trackMiscTaskId, taskCommentId) =>
        `inventory/${inventoryId}/misc-task/${trackMiscTaskId}/comment/${taskCommentId}`
    },
    package: 'inventory/package',
    vinNum: 'inventory/lookup-vin-num',
    stockNum: 'inventory/lookup-stock-num',
    uploadLink: (path, dailySalesInventoryId) => `${path}/${dailySalesInventoryId}/send-docr-upload-link`,
    location: 'inventory/update-vehicle-location',
    listOrder: 'inventory/list-order'
  },
  admin: {
    forms: {
      list: 'admin/form/list',
    },
    amFinance: {
      products: {
        single: 'admin/dealer-am-finance-product',
        list: 'admin/dealer-am-finance-product/list',
        delete: 'admin/dealer-am-finance-product/delete',
        order: 'admin/dealer-am-finance-product/sort'
      },
      lenders: {
        single: 'admin/lender',
        list: 'admin/lender/list',
        delete: 'admin/lender/delete'
      }
    },
    dealerSettings: 'admin/dealer-setting',
    dealerForm: {
      list: 'admin/dealer-form/list',
      single: 'admin/dealer-form'
    },
    dealerIncentive: {
      list: 'admin/deal-incentive/list',
      single: 'admin/deal-incentive',
      delete: 'admin/deal-incentive/delete'
    },
    emailSettings: {
      list: 'admin/email-setting/list',
      single: 'admin/email-setting'
    },
    inventoryPacks: {
      list: 'admin/inventory-pack/list',
      single: 'admin/inventory-pack',
      delete: 'admin/inventory-pack'
    },
    dealPacks: {
      list: 'admin/deal-pack/list',
      single: 'admin/deal-pack',
      delete: 'admin/deal-pack'
    },
    dealerRebates: {
      list: 'admin/dealer-rebate/list',
      single: 'admin/dealer-rebate',
      delete: 'admin/dealer-rebate/delete'
    },
    reports: {
      list: 'report',
      single: 'report',
      chart: (reportID) => `report/${reportID}/chart`,
      category: {
        list: 'report/category',
        single: 'report/category'
      },
      email: {
        list: 'report/email',
        single: 'report/email'
      }
    },
    spotInstructions: {
      common: {
        list: 'admin/spot-instruction/common/list',
        single: 'admin/spot-instruction/common',
        delete: 'admin/spot-instruction/common/delete'
      },
      auto: {
        list: 'admin/spot-instruction/automated/list',
        single: 'admin/spot-instruction/automated',
        delete: 'admin/spot-instruction/automated/delete'
      }
    },
    user: {
      list: 'user/list'
    },
    vendor: {
      list: 'vendor/list',
      single: 'vendor',
      delete: 'vendor/delete'
    },
    staff: {
      list: 'user/staff'
    },
    adminForm: {
      list: 'admin/forms/list',
      upload: dslFormId => `upload/uploadDSLForm/${dslFormId}`
    }
  },
  user: {
    profile: 'user/update-profile',
    password: 'change-password'
  },
  dailySales: {
    listByDate: 'sales-by-make-dealer-id',
    listByStockNumber: 'inventory-by-stockNo'
  },
  deliveryLog: {
    list: 'sales/deliverylog',
    epost: 'sales/epost',
    epostData: 'sales/epostData',
    rebill: 'sales/rebill'
  },
  sales: {
    print: {
      buyersOrder: 'sales/print/buyers-order',
      recap: 'sales/print/gross-recap',
      cleanUp: (salesId, dailySalesInventoryId) =>
        salesId
          ? `inventory/print/request-cleanup/${dailySalesInventoryId}/salesId/${salesId}`
          : `inventory/print/request-cleanup/${dailySalesInventoryId}`,
      twg: 'sales/print/twg-cancellation'
    },
    list: {
      order: 'sales/order',
      fallout: 'sales/fallout'
    },
    comments: {
      list: salesID => `sales/comments/list/${salesID}`,
      add: salesID => `sales/comments/${salesID}`,
      delete: (sales_id, daily_sales_comment_id) => `sales/comments/${sales_id}/${daily_sales_comment_id}`,
    },
    dealtasks: {
      list: 'sales/deal-tasks/list'
    },
    epost: {
      get: 'sales/epostData',
      save: 'sales/epost'
    },
    trade : {
      get: (salesId, tradeId) => `sales/${salesId}/trade/${tradeId}`,
      delete: (salesId, tradeId) => `sales/${salesId}/trade/${tradeId}`
    },
    automatedSpotInstructions: 'sales-automated-spot-instruction',
    backout: 'sales/backout',
    backoutDate: 'sales/backoutdate',
    carryover: 'sales/carryover',
    activityLog: salesID => `sales/activity-log/list/${salesID}`,
    rebate: 'sales/rebate/list',
    dealerIncentive: 'sales/dealer-incentive/list',
    dealerpack: 'sales/dealer-pack/list',
    single: 'sales',
    rebill: 'sales/rebill',
    save: salesId => (salesId ? `sales/${salesId}` : 'sales'),
    order: salesId => `sales/order/${salesId}`,
    estimatedDeliveryDate: salesId => `sales/estimateddeliverydate/${salesId}`,
    delivered: {
      save: salesId => `sales/delivered/${salesId}`,
      printedGrossRecap: salesId => `/sales/printedGrossRecapForDelivery/${salesId}`
    },
    fallout: salesId => `sales/fallout/${salesId}`,
    updateWarrantyType: salesId => `/sales-update-warrantytype/${salesId}`,
    pushToTTMS: salesId => `/sales/manual-push-to-ttms/${salesId}`,
    addVin: salesId => `sales/add-vin/${salesId}`
  },
  globalSearch: {
    search: 'search'
  },
  uploads: {
    downPayment: {
      temp: 'upload/temp-sales',
      view: 'viewattachment/dealDP',
      delete: 'deleteattachment/sales/downpayment',
    },
    inventory: {
      temp: 'upload/temp-inventory',
      upload: 'upload/inventory',
      delete: 'deleteattachment/inventory',
      view: 'viewattachment/inventory',
      activityLog: 'viewattachment/activityLog'
    },
    rebate: {
      temp: 'admin/dealer-rebate/upload/attachment/temp',
      view: rebateID => `admin/dealer-rebate/${rebateID}/attachment`,
      delete: rebateID => `admin/dealer-rebate/${rebateID}/attachment`
    },
    sales: {
      temp: 'upload/temp-sales',
      upload: 'upload/sales',
      delete: 'deleteattachment/sales',
      view: 'viewattachment/sales',
      viewRebate: 'viewattachment/sales/rebate',
      viewReport: 'sales/viewreport',
    },
    temp: {
      delete: 'deleteattachment/temp',
      view: 'viewattachment/temp/',
    }
  },
  print: {
    inventory: {
      vehicleInfo: 'inventory/print/vehicle-info',
      requestDetail: 'inventory/print/request-detail',
      buyersGuide: 'inventory/print/buyers-guide',
      permissionToDrive: 'inventory/print/permission-to-drive',
      requestCleanup: 'inventory/print/request-cleanup',
      inspectionForm: 'inventory/print/inspection-form'
    }
  },
  AccountingTasks: {
    FE_gross: {
      list: 'accounting-task/fe-gross-analysis'
    },
    BE_gross: {
      list: 'accounting-task/be-gross-analysis'
    },
    deal_count: {
      list: 'accounting-task/deal-count'
    }
  },
  upload: {
    initiate: 'upload/initiate',
    chunk: 'upload/chunk'
  }
};
